import { useCallback, useState } from 'react';

import { acceptInvite, checkInviteToken } from '@/lib/api';

export enum InviteAuthState {
    PRE_AUTH = 'pre-auth',
    NOT_AUTHENTICATED = 'not-authenticated',
    AUTHENTICATED = 'authenticated',
}

export interface InviteTokenAuthData {
    authState: InviteAuthState;
    checkAuth: () => void;
    acceptInvite: (firstName: string | undefined, lastName: string, password: string) => Promise<void>;
}

export const useInviteTokenAuth = (token?: string): InviteTokenAuthData => {
    const [authState, setAuthState] = useState(InviteAuthState.PRE_AUTH);

    const checkAuth = useCallback(async () => {
        if (token === undefined) {
            setAuthState(InviteAuthState.NOT_AUTHENTICATED);
        }
        try {
            await checkInviteToken({ auth: token });
            setAuthState(InviteAuthState.AUTHENTICATED);
        } catch (_e) {
            setAuthState(InviteAuthState.NOT_AUTHENTICATED);
        }
    }, [token]);

    const _acceptInvite = useCallback(
        async (firstName: string | undefined, lastName: string, password: string) => {
            await acceptInvite({
                body: {
                    first_name: firstName,
                    last_name: lastName,
                    password,
                },
                auth: token,
            });
        },
        [token]
    );

    return {
        authState,
        checkAuth,
        acceptInvite: _acceptInvite,
    };
};
